import { render, staticRenderFns } from "./screenTimingTask.vue?vue&type=template&id=3945d0a0&"
import script from "./screenTimingTask.vue?vue&type=script&lang=js&"
export * from "./screenTimingTask.vue?vue&type=script&lang=js&"
import style0 from "./screenTimingTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports